import React, { useEffect, useState } from 'react';
import { X, CheckCircle, XCircle, AlertTriangle, Info } from 'lucide-react';

const MessageItem = ({ message, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);
  // 使用消息对象中的 isLeaving 状态
  const isLeaving = message.isLeaving || false;

  // 进入动画
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 10);
    return () => clearTimeout(timer);
  }, []);

  // 处理关闭（直接调用 onClose，动画由 Context 处理）
  const handleClose = () => {
    onClose(message.id);
  };

  // 获取消息类型样式
  const getMessageStyles = (type) => {
    const baseStyles = "backdrop-blur-sm border shadow-lg";
    
    switch (type) {
      case 'success':
        return `${baseStyles} bg-green-500/90 border-green-400/50 text-white`;
      case 'error':
        return `${baseStyles} bg-red-500/90 border-red-400/50 text-white`;
      case 'warning':
        return `${baseStyles} bg-orange-500/90 border-orange-400/50 text-white`;
      case 'info':
      default:
        return `${baseStyles} bg-blue-500/90 border-blue-400/50 text-white`;
    }
  };

  // 获取消息图标
  const getMessageIcon = (type) => {
    const iconProps = { className: "w-5 h-5 flex-shrink-0" };
    
    switch (type) {
      case 'success':
        return <CheckCircle {...iconProps} />;
      case 'error':
        return <XCircle {...iconProps} />;
      case 'warning':
        return <AlertTriangle {...iconProps} />;
      case 'info':
      default:
        return <Info {...iconProps} />;
    }
  };

  return (
    <div
      className={`
        transform transition-all duration-300 ease-out
        ${isVisible && !isLeaving 
          ? 'translate-y-0 opacity-100 scale-100' 
          : isLeaving 
            ? '-translate-y-4 opacity-0 scale-95'
            : 'translate-y-4 opacity-0 scale-95'
        }
      `}
    >
      <div
        className={`
          ${getMessageStyles(message.type)}
          rounded-lg px-4 py-3 flex items-center space-x-3
          min-w-[300px] max-w-[500px] mx-auto
          pointer-events-auto
          shadow-lg backdrop-blur-sm
        `}
      >
        {/* 消息图标 */}
        {getMessageIcon(message.type)}
        
        {/* 消息文本 */}
        <div className="flex-1 text-sm font-medium">
          {message.text}
        </div>
        
        {/* 关闭按钮 */}
        {message.closable && (
          <button
            onClick={handleClose}
            className="flex-shrink-0 p-1 hover:bg-white/20 rounded-md transition-colors"
            aria-label="Close message"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
};

export default MessageItem;
